
import { toast } from "react-hot-toast";
import i18n from "i18next"; // this gives access outside React components

// export const showUnderDevelopment = () => {
//    toast(i18n.t("common.under_development"));
// };

export const showUnderDevelopment = () => {
  toast(i18n.t("common.under_development"), {
    icon: '⚠️',
  });
};
